export default function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-hierarchy/src/hierarchy/sort.js
// module id = ../../../../d3-hierarchy/src/hierarchy/sort.js
// module chunks = 3